// CalendarUrine.jsx
import "./styles.scss";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { Calendar } from "antd";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { BEDWETTING_TYPE_VALUE } from "../constants";

const CalendarUrine = ({ data, dateSelected, setDateSelected, fetchData }) => {
  const { t } = useTranslation();

  const dateCellRender = (value) => {
    const dataToday = data[value.format("YYYY-MM-DD")];

    return (
      <div className="calendar-cell-icons">
        {dataToday?.icons.map((icon, index) => (
          <img key={index} src={icon} className="calendar-icon-img" />
        ))}
      </div>
    );
  };

  const cellRender = (current, info) => {
    if (info.type === "date") return dateCellRender(current);
    return info.originNode;
  };

  const handleNextMonth = () => {
    fetchData(dateSelected.add(1, "months"));
    setDateSelected((cur) => cur.add(1, "months"));
  };

  const handlePrevMonth = () => {
    fetchData(dateSelected.subtract(1, "months"));
    setDateSelected((cur) => cur.subtract(1, "months"));
  };

  const handleSelect = (date) => {
    setDateSelected(date);
  };

  return (
    <div className="calendar-urine-container">
      <div className="calendar-next-prev">
        <LeftOutlined className="calendar-prev" onClick={handlePrevMonth} />
        {dayjs(dateSelected).format(t("graph.chartTime"))}
        <RightOutlined className="calendar-next" onClick={handleNextMonth} />
      </div>

      <div className="main-section-calendar">
        <Calendar
          className="calendar-urine"
          cellRender={cellRender}
          value={dateSelected}
          onSelect={handleSelect}
        />
      </div>

      <div className="calendar-urine-legend">
        <div className="calendar-urine-icons">
          <div className="calendar-icon">
            <img src="/icons/medal.webp" alt="" />
            {t("graph.calendarPage.noBedwettingUntilMorning")}
          </div>
          <div className="calendar-icon">
            <img src="/icons/blueWater1.webp" alt="" />
            {t(
              BEDWETTING_TYPE_VALUE.the_alarm_went_off_and_I_woke_up_to_stop_it
                .title
            )}
          </div>
          <div className="calendar-icon">
            <img src="/icons/toilet.webp" alt="" />
            {t("graph.calendarPage.toilet")}
          </div>
          <div className="calendar-icon">
            <img src="/icons/blueWater.webp" alt="" />
            {t(
              BEDWETTING_TYPE_VALUE
                .the_alarm_went_off_but_I_couldnt_wake_up_by_myself.title
            )}
          </div>
        </div>
        <div className="calendar-icon">
          <img src="/icons/medicine.webp" alt="" />
          {t("graph.calendarPage.tookMedication")}
        </div>
      </div>
    </div>
  );
};

export default CalendarUrine;
